<div class="main-page">
  <div class="plans-area">
    <section class="message-area">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="chat-area">
              <!-- chatlist -->
              <div class="chatlist">
                <div class="modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="chat-header">
                      <div class="msg-search">
                        <i class="fa fa-search chat-search-icon" aria-hidden="true"></i>
                        <input
                          type="text"
                          class="form-control chat-search-input"
                          id="inlineFormInputGroup"
                          placeholder="Search..."
                          aria-label="search"
                          [(ngModel)]="searchTerm"
                          (ngModelChange)="filterUsers()"
                        />
                      </div>
                    </div>
                    <div class="chat-tabs-container">
                      <ul
                        class="nav nav-pills nav-tabs nav-chat"
                        role="tablist"
                        id="chat-tab"
                      >
                        <li class="nav-item" role="presentation">
                          <button
                            class="nav-link"
                            id="all-tab"
                            data-toggle="pill"
                            data-target="#all"
                            type="button"
                            role="tab"
                            aria-controls="all"
                            [class.active]="activeTab==='all'"
                            [attr.aria-selected]="activeTab==='all'"
                            (click)="getSelectedTab('all')"
                          >
                            All
                          </button>
                        </li>

                      <li class="nav-item" role="presentation">
                          <button
                            class="nav-link"
                            id="public"
                            data-toggle="pill"
                            data-target="#public"
                            type="button"
                            role="tab"
                            aria-controls="public"
                            [class.active]="activeTab==='public'"
                            [attr.aria-selected]="activeTab==='public'"
                            (click)="getSelectedTab('public')"
                          >
                            Public
                          </button>
                      </li>

                        <li class="nav-item" role="presentation">
                          <button
                            class="nav-link"
                            id="friends-tab"
                            data-toggle="pill"
                            data-target="#friends"
                            type="button"
                            (click)="getSelectedTab('followers')"
                            role="tab"
                            aria-controls="friends"
                            [class.active]="activeTab==='followers'"
                            [attr.aria-selected]="activeTab==='followers'"
                          >
                            Followers
                          </button>
                        </li>

                        <li class="nav-item" role="presentation">
                          <button
                            class="nav-link"
                            id="merchants-tab"
                            data-toggle="pill"
                            data-target="#merchants"
                            type="button"
                            role="tab"
                            (click)="getSelectedTab('Ministries')"
                            aria-controls="merchants"
                            [class.active]="activeTab==='Ministries'"
                            [attr.aria-selected]="activeTab==='Ministries'"
                          >
                            Ministries
                          </button>
                        </li>
                      </ul>
                    </div>
                    <div class="modal-body">
                      <!-- chat-list -->
                      <div class="chat-lists">
                        <!-- All Tabs user List -->
                        <div
                          class="tab-content"
                          id="chat-tabContent"
                        >
                          <div
                            class="tab-pane fade"
                            id="all"
                            role="tabpanel"
                            aria-labelledby="all-tab"
                            [class.show]="activeTab==='all'"
                            [class.active]="activeTab==='all'"
                          >
                            <ng-container
                              *ngIf="allTabsUserList?.length > 0; else noallUser"
                            >
                              <div
                                class="chat-list"
                                *ngFor="let user of allTabsUserList"
                              >
                                <div
                                  href="#"
                                  class="d-flex align-items-center singleUser cursorPosition"
                                  (click)="initiateMerchantChat(user)"
                                  [class.active]="user.id === selectedUser?.id"
                                  [ngClass]="{ 'new-message': user?._id === activeMessageSenderId, 'active-user': user?._id === contactUser }"
                                >
                                  <div class="flex-shrink-0">
                                    <ng-container
                                      *ngIf="
                                        user?.photo;
                                        else defaultAvatar
                                      "
                                    >
                                      <img
                                        class="img-fluid userimg"
                                        [src]="setUrl(user?.photo)"
                                        alt="user img"
                                        (error)="onImageError($event)"
                                      />
                                    </ng-container>
                                    <ng-template #defaultAvatar>
                                      <img
                                        class="img-fluid userimg"
                                        src="../../../../assets/person.png"
                                        alt="default avatar"
                                      />
                                    </ng-template>
                                    <span
                                      *ngIf="user.unReadMessage > 0"
                                      class="active"
                                    ></span>
                                  </div>
                                  <div class="flex-grow-1 mx-2">
                                    <h3>
                                      {{user.userName || user.firstName + user.lastName ||user.name}}
                                    </h3>
                                    <p *ngIf="user.unReadMessage > 0">
                                      {{ user.unReadMessage }} new messages
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                            <ng-template #noallUser>
                              <p class="p-3">No users found</p>
                            </ng-template>
                          </div>
                          <!-- public tab -->

                          <div
                            class="tab-pane fade"
                            id="public"
                            role="tabpanel"
                            aria-labelledby="public"
                            [class.show]="activeTab==='public'"
                            [class.active]="activeTab==='public'"
                          >
                            <ng-container
                              *ngIf="publicTabsUserList?.length > 0; else noPublicUser"
                            >
                              <div
                                class="chat-list"
                                *ngFor="let user of publicTabsUserList"
                              >
                                <div
                                  href="#"
                                  class="d-flex align-items-center singleUser cursorPosition"
                                  (click)="initiateMerchantChat(user)"
                                  [class.active]="user.id === selectedUser?.id"
                                  [ngClass]="{ 'new-message': user?._id === activeMessageSenderId, 'active-user': user?._id === contactUser }"
                                >
                                  <div class="flex-shrink-0">
                                    <ng-container
                                      *ngIf="
                                        user?.photo;
                                        else defaultAvatar
                                      "
                                    >
                                      <img
                                        class="img-fluid userimg"
                                        [src]="setUrl(user?.photo)"
                                        alt="user img"
                                        (error)="onImageError($event)"
                                      />
                                    </ng-container>
                                    <ng-template #defaultAvatar>
                                      <img
                                        class="img-fluid userimg"
                                        src="../../../../assets/person.png"
                                        alt="default avatar"
                                      />
                                    </ng-template>
                                    <span
                                      *ngIf="user.unReadMessage > 0"
                                      class="active"
                                    ></span>
                                  </div>
                                  <div class="flex-grow-1 mx-2">
                                    <h3>
                                      {{user?.userName ||user?.firstName + user?.lastName ||user?.name}}
                                    </h3>
                                    <p *ngIf="user.unReadMessage > 0">
                                      {{ user.user?.unReadMessage }} new messages
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                            <ng-template #noPublicUser>
                              <p class="p-3">No users found</p>
                            </ng-template>
                          </div>


                          <!-- people tabs user list -->
                          <div
                            class="tab-pane fade"
                            id="friends"
                            role="tabpanel"
                            aria-labelledby="friends-tab"
                            [class.show]="activeTab==='followers'"
                            [class.active]="activeTab==='followers'"
                          >
                            <ng-container
                              *ngIf="friends?.length > 0; else noFriends"
                            >
                              <div
                                class="chat-list"
                                *ngFor="let user of friends"
                              >
                                <div
                                  href="#"
                                  class="d-flex align-items-center singleUser"
                                  (click)="initiateMerchantChat(user)"
                                  [class.active]="user.id === selectedUser?.id"
                                >
                                  <div class="flex-shrink-0">
                                    <img
                                      class="img-fluid userimg"
                                      [src]="setUrl(user?.photo)"
                                      alt="user img"
                                      (error)="onImageError($event)"
                                    />
                                    <span
                                      *ngIf="user.unReadMessage > 0"
                                      class="active"
                                    ></span>
                                  </div>
                                  <div class="flex-grow-1 mx-2">
                                    <h3>
                                      {{ user.name || user.userName }}
                                    </h3>
                                    <p *ngIf="user.unReadMessage > 0">
                                      {{ user.unReadMessage }} new messages
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                            <ng-template #noFriends>
                              <p class="p-3">No users found</p>
                            </ng-template>
                          </div>
                          <!-- ministries tabs user list -->
                          <div
                            class="tab-pane fade"
                            id="merchants"
                            role="tabpanel"
                            aria-labelledby="merchants-tab"
                            [class.show]="activeTab==='Ministries'"
                            [class.active]="activeTab==='Ministries'"
                          >
                            <ng-container
                              *ngIf="ministriesUserList?.length > 0; else noMerchants"
                            >
                              <div
                                class="chat-list"
                                *ngFor="let user of ministriesUserList"
                              >
                                <div
                                  href="#"
                                  class="d-flex align-items-center singleUser"
                                  (click)="initiateMerchantChat(user)"
                                  [class.active]="user.id === selectedUser?.id"
                                >
                                  <div class="flex-shrink-0">
                                    <img
                                      class="img-fluid userimg"
                                      [src]="setUrl(user?.photo)"
                                      alt="user img"
                                      (error)="onImageError($event)"
                                    />
                                    <span
                                      *ngIf="user.unReadMessage > 0"
                                      class="active"
                                    ></span>
                                  </div>
                                  <div class="flex-grow-1 mx-2">
                                    <h3>
                                      {{ user.name || user.userName }}
                                    </h3>
                                    <p *ngIf="user.unReadMessage > 0">
                                      {{ user.unReadMessage }} new messages
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                            <ng-template #noMerchants>
                              <p class="p-3">No users found</p>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                      <!-- chat-list -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- chatlist -->

              <!-- chatbox -->
              <div class="chatbox">
                <div class="header-actions">
                  <div class="dropdown">
                    <button
                      class="btn btn-newchat dropdown-toggle"
                      type="button"
                      (click)="toggleDropdown()"
                    >
                      <i class="fa fa-plus"></i> New Chat
                    </button>
                    <div class="dropdown-menu" *ngIf="isDropdownOpen">
                      <a class="dropdown-item" (click)="selectChatType('followers')">
                        <i class="fa fa-handshake-o"></i> Followers
                      </a>
                      <a class="dropdown-item" (click)="selectChatType('ministry')">
                        <i class="fa fa-university"></i> Ministry
                      </a>
                    </div>
                  </div>
                </div>

                <!-- New Chat User List -->
                <div class="new-chat-container" *ngIf="showNewChatList">
                  <div class="new-chat-header">
                    <div class="header-text">
                      <i class="fa fa-users"></i>
                      <span>Select User to Chat</span>
                    </div>
                    <button
                      type="button"
                      class="btn-close-chat"
                      (click)="toggleNewChatList()"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="user-scroll-container">
                    <div class="user-scroll">
                      <div
                        *ngFor="let user of newChatUser"
                        class="user-item"
                        (click)="initiateMerchantChat(user)"
                      >
                        <div class="user-avatar">
                          <img
                            [src]="user.photo || '../../../../assets/person.png'"
                            alt="user avatar"
                            class="user-photo"
                            (error)="onImageError($event)"
                          />
                        </div>
                        <div class="user-details">
                          <span class="user-name">{{
                            user.name || user.userName || (user.firstName + ' ' + user.lastName)
                          }}</span>
                          <span class="user-status">Available</span>
                        </div>
                        <div class="chat-icon-container">
                          <i class="fa fa-commenting"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Existing Chat Window -->
                <div class="modal-dialog-scrollable" *ngIf="!showNewChatList">
                  <div class="modal-content" *ngIf="chatStatus">
                    <div class="msg-head">
                      <div class="row">
                        <div class="col-8">
                          <div class="d-flex align-items-center">
                            <div class="flex-shrink-0">
                              <img
                                *ngIf="postUserImage"
                                class="img-fluid userImage"
                                [src]="setUrl(postUserImage)"
                                alt="user img"
                                (error)="onImageError($event)"
                              />
                              <img
                                *ngIf="!postUserImage"
                                class="img-fluid userImage"
                                src="../../../../assets/person.png"
                                alt="default avatar"
                              />
                            </div>
                            <div class="flex-grow-1 mx-2">
                              <h3>{{ userName }}</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-bodys" style="height: 320px">
                      <div class="msg-body" #chatContainer>
                        <ul>
                          <li
                            *ngFor="let data of chat"
                            [ngClass]="{
                              sender: data.senderId !== loginUser,
                              repaly: data.senderId === loginUser
                            }"
                          >
                            <p>{{ data.message }}</p>
                            <span class="time">{{
                              getTime(data.createdAt)
                            }}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="send-box">
                      <div style="display: flex">
                        <input
                          type="text"
                          class="form-control"
                          aria-label="message…"
                          [(ngModel)]="newMessage"
                          (ngModelChange)="getMessageInput($event)"
                          (keyup.enter)="sendMessage()"
                          placeholder="Enter your message..."
                        />
                        <button (click)="sendMessage()" type="button">
                          <i class="fa fa-paper-plane" aria-hidden="true"></i>
                          Send
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="modal-content" *ngIf="!chatStatus && !showNewChatList">
                    <h5 class="chatCenter">Chat</h5>
                  </div> -->
                </div>
              </div>
              <!-- chatbox -->
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
